module.exports = __webpack_public_path__ + "media/icons/offer-details-motocykle@3x-6e7927b9.svg";